import { Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import { MensajeAdvertencia, MensajeError, MensajeExito } from '@cf-v5-workspace/messages';
import { abrirModalCargando, cerrarModalCargando, isDefined, isDefinedAndNotEmpty, responseValidator, UserException } from '@cf-v5-workspace/utils';
import ResponseModel from '@cf-v5-workspace/utils/models/response.model';
import AdjuntarArchivosModel from '../../models/adjuntar-archivos.model';
import ArchivosAdjuntosContenidosModel from '../../models/archivos-adjuntos-contenidos.model';
import ObtenerInformacionAdjuntosModel from '../../models/obtener-informacion-adjuntos.model';
import { AdjuntarArchivosService } from '../../services/adjuntar-archivos.service';
import { SessionStorageService } from '../../services/session-storage.service';
import { CategoriasEstados } from '@cf-v5-workspace/enums';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap'
@Component({
	selector: 'app-adjuntar-archivos',
	templateUrl: './adjuntar-archivos.component.html',
	styleUrls: ['./adjuntar-archivos.component.css']
})
export class AdjuntarArchivosComponent {

	documentoReferenciado: string = "";
	adjuntosAgregados: Array<ArchivosAdjuntosContenidosModel> = new Array<ArchivosAdjuntosContenidosModel>();
	listaArchivosAdjuntos: Array<AdjuntarArchivosModel>;
	modal: NgbModalRef;

	@Input() adjuntarArchivo: AdjuntarArchivosModel;
	@Input() categoria: CategoriasEstados;
	constructor (
		private adjuntarArchivosService: AdjuntarArchivosService,
		private sessionStorageService: SessionStorageService,
		private modalService: NgbModal
	) {}

	inicioComponent(contenido: NgbModalRef) {
		this.abrirModalAdjuntarArchivos(contenido);
		this.obtenerAdjuntos();
	}

	/**
	 * Método que se encarga de abrir el modal para adjuntar archivos
	 * @author Bvelez
	 */
	abrirModalAdjuntarArchivos(contenido: NgbModalRef) {
		this.modal = this.modalService.open(contenido, {centered: true});
	}
	
	/**
	 * este metodo se encarga de obtener todos los adjuntos relacionados con este documento en cuestion
	 * @author Bvelez
	 */
	obtenerAdjuntos(): void {
		try {

			let datos = new ObtenerInformacionAdjuntosModel();
			
			datos.categoria = Number(this.categoria);
			datos.adjunto = this.adjuntarArchivo;
			abrirModalCargando()
			const servicio = this.adjuntarArchivosService.obtenerAdjuntos(datos).subscribe(
				(response: ResponseModel<Array<AdjuntarArchivosModel>>) => {
					cerrarModalCargando();
					if (isDefinedAndNotEmpty(response)) {
						this.listaArchivosAdjuntos = response.datos;
					} else {
						this.descartar();
					}
					servicio.unsubscribe();
				}, error => {
					cerrarModalCargando();
					UserException('error al obtener los adjuntos', error, `VisualizarAdjuntos_${this.obtenerAdjuntos.name}`);
					this.descartar();
					servicio.unsubscribe();
				}
			)
		}
		catch (error) {
			cerrarModalCargando();
			UserException('error al obtener los adjuntos', error, `VisualizarAdjuntos_${this.obtenerAdjuntos.name}`);
			this.descartar();
		}
	}

	/**
	 * este metodo se encarga de de seleccionar el archivo a adjuntar 
	 * @param evento
	 * @author Bvelez
	 */
	seleccionarAdjuntos(evento): void {
		try {
			if (evento.target.files.length > 0) {

				let archivos = evento.target.files;

				if (archivos.length <= 5) {

					for (let i = 0; i < archivos.length; i++) {
						this.agregarAjuntos(archivos[i]);
					}
				}
				else {
					MensajeAdvertencia('Solo están permitidos 5 archivos adjuntos');
				}

				let formData = new FormData();
				formData = this.construirFormData(this.adjuntosAgregados);
				this.adjuntosAgregados = new Array<ArchivosAdjuntosContenidosModel>();
				formData.append('categoria', JSON.stringify(this.categoria));
				formData.append('adjuntarArchivo', JSON.stringify(this.adjuntarArchivo));
				this.listaArchivosAdjuntos = new Array<AdjuntarArchivosModel>();
				abrirModalCargando();
				const servicio = this.adjuntarArchivosService.agregarContenidoAdjunto(formData).subscribe(
					(response: ResponseModel<Array<AdjuntarArchivosModel>>) => {
						cerrarModalCargando();
						if(responseValidator(response)) {
							if (isDefinedAndNotEmpty(response.datos)) {
								response.datos.map((archivo) => {
									this.listaArchivosAdjuntos.push(archivo);
								})
							}
							MensajeExito('Se guardaron correctamente los archivos');
						}
						servicio.unsubscribe();
					}, error => {
						UserException('error al adjuntar los archivos', error, `${this.seleccionarAdjuntos.name}`);
						servicio.unsubscribe();
					}
				);
			}
		}
		catch (error) {
			UserException('error al seleccionar adjuntos', error, `VisualizarAdjuntos_${this.seleccionarAdjuntos.name}`);
		}
	}

	/**
	 * estructura un array con los archivos a adjuntar
	 * @param archivo 
	 * @author cloaiza
	 */
	agregarAjuntos(archivo: File) {
		try {
			const adjuntoModelTmp = new ArchivosAdjuntosContenidosModel();

			adjuntoModelTmp.id = this.adjuntosAgregados.length + 1;
			adjuntoModelTmp.nombre = archivo.name;
			adjuntoModelTmp.archivoCompleto = archivo;

			this.adjuntosAgregados.push(adjuntoModelTmp);

		}
		catch (error) {
			UserException('error al adjuntar los archivos', error, `${this.agregarAjuntos.name}`);
		}
	}

	/**
	 * pasa los archivos seleccionados al formData 
	 * para ser pasados al back 
	 * @param adjuntos 
	 * @author cloaiza
	 * @returns 
	 */
	construirFormData(adjuntos: Array<ArchivosAdjuntosContenidosModel>): FormData {
		const formData = new FormData();
		try {
			if (isDefinedAndNotEmpty(adjuntos)) {

				let index = 1;

				adjuntos.forEach(registro => {

					if (isDefinedAndNotEmpty(registro.archivoCompleto)) {
						formData.append(`file${index}`, registro.archivoCompleto, registro.archivoCompleto.name);
						index++;
					}

				});
			}
		} catch (error) {
			UserException('se genero un error al construir el form data ', error, `${this.construirFormData.name}`);
		}
		return formData;
	}

	/**
	 * este metodo se encarga de descargar el archivo seleccionado del grid
	 * @param informacion 
	 * @author cloaiza
	 */
	descargarAdjunto(informacion: AdjuntarArchivosModel): void {
		try {
			let ruta: string = undefined;

			this.adjuntarArchivosService.getDefaultSettings().subscribe(
				(m => {
					const rutaDoc = informacion.rutaArchivo.split('Archivos_Adjuntos');
					ruta = 'Archivos_Adjuntos' + rutaDoc[1];

					if (isDefined(ruta)) {
						let globalsObtenidas = this.sessionStorageService.obtenerInfoSesion();
						let rutaRecursos = globalsObtenidas.base_url + '/Recursos//' + globalsObtenidas.idEmpresa + '//';
						
						const regEx = /\\/g 
						ruta = ruta.replace(regEx,'//');
						rutaRecursos += ruta;

						window.open(rutaRecursos);
					}
				}),
				error => {
					UserException('error al descargar los adjuntos', error, `VisualizarAdjuntos_${this.descargarAdjunto.name}`);
				}
			);
		}
		catch (error) {
			UserException('error al descargar los adjuntos', error, `VisualizarAdjuntos_${this.descargarAdjunto.name}`);
		}
	}

	/**
	 * Método que se encarga de cerrar el modal
	 * @author Bvelez
	 */
	descartar() {
		if (isDefinedAndNotEmpty(this.modal)) {
			this.modal.close();	
		}
		
	}

}
